import { FunctionComponent } from "react";
import ApprovalMessage from "./ApprovalMessage";
import styles from "./PopupComponent.module.css";
import { Button } from "@mui/material";

interface PopupProps{
  handleClose : () => void,
  title: string,
  subTitle: string
}

const PopupComponent: FunctionComponent<PopupProps> = ({handleClose,title,subTitle}) => {
  return (
      <div className={styles.topSection}>
        <ApprovalMessage title={title} subTitle={subTitle}/>
        <div className={styles.cta}>
          <div className={styles.button} data-testid='dialogPopClose' onClick={handleClose}>
            <Button
              fullWidth
              sx={{
                height: '44px',
                borderRadius: 0,
                '&.MuiButton-root':{
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  fontSize: "var(--sub-s-h2-16-semibold-center-size)",
                  fontFamily: "var(--body-b3-12-semibold-left)",
                  color: "var(--neutral-white)",
                  backgroundColor: "var(--branding-secondary)"
               },
              }}
            >Okay</Button>
          </div>
        </div>
      </div>
  );
};

export default PopupComponent;
